/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type StakeholderImageDTO = {
    imageContent: string;
    imageType: StakeholderImageDTO.imageType;
    mimeExt?: string;
};

export namespace StakeholderImageDTO {

    export enum imageType {
        DOCUMENT_FRONT_BASE64 = 'DOCUMENT_FRONT_BASE64',
        DOCUMENT_BACK_BASE64 = 'DOCUMENT_BACK_BASE64',
        SELFIE_BASE64 = 'SELFIE_BASE64',
        LIVENESS_BASE64 = 'LIVENESS_BASE64',
        PASSPORT_BIO_PAGE_BASE64 = 'PASSPORT_BIO_PAGE_BASE64',
    }


}
